import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getCartQueryKey from '@nike/shop-apis/buy/carts/v2/get-query-key';
import getProductFeedThreadsQueryKey from '@nike/shop-apis/product-feed-threads/v2/get-query-key';
var CLASSIFICATION_CORE_BUY_FLOW = 'core buy flow';
var CHECKOUT_INTENT_START = 'Checkout Intent Start';
var CHANGE_VIEW = 'changeView';
var getProduct = function getProduct(productId) {
  var _window$NikeShop;
  var _ref = ((_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.__INTERNAL_USE__) || {},
    queryClient = _ref.queryClient;
  return (queryClient === null || queryClient === void 0 ? void 0 : queryClient.getQueryData(getProductFeedThreadsQueryKey({
    productId: productId
  }))) || {};
};
var shapeProductListData = function shapeProductListData(productId) {
  var productData = getProduct(productId);
  var pid = productData.pid,
    productType = productData.productType,
    brand = productData.brand,
    styleColor = productData.styleColor,
    content = productData.content;
  var _ref2 = content || {},
    name = _ref2.title;
  return {
    brand: brand,
    cloudProductId: productId,
    name: name,
    prodigyProductId: pid,
    productId: pid,
    productType: productType,
    styleColor: styleColor
  };
};
var checkoutClickEvent = function checkoutClickEvent(_ref3) {
  var _window$NikeShop2, _queryClient$getQuery;
  var checkoutType = _ref3.checkoutType;
  var _ref4 = ((_window$NikeShop2 = window.NikeShop) === null || _window$NikeShop2 === void 0 ? void 0 : _window$NikeShop2.__INTERNAL_USE__) || {},
    queryClient = _ref4.queryClient;
  var cartItems = (queryClient === null || queryClient === void 0 || (_queryClient$getQuery = queryClient.getQueryData(getCartQueryKey())) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.items) || [];
  var products = cartItems.map(function (item) {
    var skuId = item.skuId,
      quantity = item.quantity,
      priceInfo = item.priceInfo;
    var total = priceInfo.total;
    var productId = item === null || item === void 0 ? void 0 : item.productId;
    var productData = shapeProductListData(productId);
    return _objectSpread({
      price: total,
      quantity: quantity,
      sku: skuId
    }, productData);
  });
  return {
    classification: CLASSIFICATION_CORE_BUY_FLOW,
    eventName: CHECKOUT_INTENT_START,
    eventType: CHANGE_VIEW,
    properties: {
      checkoutType: checkoutType
    },
    products: products
  };
};
export default checkoutClickEvent;